module.exports = __webpack_public_path__ + "img/header-memoireRings@2x.385d60a.webp";